var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECE9F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2DEEC",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33385_168122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8333 29.6663V34.6663C28.8333 35.1246 29.2083 35.4996 29.6667 35.4996H34.6667C35.125 35.4996 35.5 35.1246 35.5 34.6663V29.6663C35.5 29.2079 35.125 28.8329 34.6667 28.8329H29.6667C29.2083 28.8329 28.8333 29.2079 28.8333 29.6663ZM21.3333 35.4996H26.3333C26.7917 35.4996 27.1667 35.1246 27.1667 34.6663V29.6663C27.1667 29.2079 26.7917 28.8329 26.3333 28.8329H21.3333C20.875 28.8329 20.5 29.2079 20.5 29.6663V34.6663C20.5 35.1246 20.875 35.4996 21.3333 35.4996ZM20.5 21.3329V26.3329C20.5 26.7913 20.875 27.1663 21.3333 27.1663H26.3333C26.7917 27.1663 27.1667 26.7913 27.1667 26.3329V21.3329C27.1667 20.8746 26.7917 20.4996 26.3333 20.4996H21.3333C20.875 20.4996 20.5 20.8746 20.5 21.3329ZM31.2917 19.9996L27.75 23.5329C27.425 23.8579 27.425 24.3829 27.75 24.7079L31.2917 28.2496C31.6167 28.5746 32.1417 28.5746 32.4667 28.2496L36.0083 24.7079C36.3333 24.3829 36.3333 23.8579 36.0083 23.5329L32.475 19.9996C32.15 19.6746 31.6167 19.6746 31.2917 19.9996Z",
    fill: "#402080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33385_168122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyIcon);
export default __webpack_public_path__ + "static/media/modify-icon.0f2d86f085c6b31ad593f1eb93391bd2.svg";
export { ForwardRef as ReactComponent };